'use client'

import React from 'react'

interface State { hasError: boolean; error: Error | null }

export class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  State
> {
  constructor(props: { children: React.ReactNode }) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center p-6 text-center bg-muted/20">
          <span className="text-5xl mb-4" role="img" aria-label="Warning">⚠️</span>
          <h1 className="text-xl font-bold mb-2">Something went wrong</h1>
          <p className="text-sm text-muted-foreground mb-6 max-w-sm">
            An unexpected error occurred. Your data is safe — please refresh the page.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="rounded-xl bg-chalk-yellow px-6 py-3 text-sm font-bold text-foreground hover:opacity-90 transition-opacity"
          >
            Refresh page
          </button>
          <button
            onClick={() => { window.location.href = '/' }}
            className="mt-3 text-sm text-muted-foreground underline underline-offset-2"
          >
            Go to home
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
